// extracted by mini-css-extract-plugin
export var black = "_3a-6";
export var brand = "_3a-1";
export var ddefault = "_3a-0";
export var error = "_3a-3";
export var gray = "_3a-2";
export var highContrast = "_3a-8";
export var outline = "_3a-7";
export var success = "_3a-5";
export var warning = "_3a-4";